<mat-toolbar class="mat-primary">
  <span fxFlex>{{ inputData.title }} auswählen</span>
  <mat-icon class="cursor-mat-element" (click)="cancelModal()">close</mat-icon>
</mat-toolbar>

<mat-dialog-content>
  <div fxLayout="column" fxFlexAlign="stretch" style="padding: 1rem">
    <div fxLayout="row" fxFlex="100">
      <h2>
        {{ inputData.selectedItem.displayName }}
      </h2>
    </div>
  </div>

  <div fxLayout="column" fxFlexAlign="stretch" style="padding: 1rem">
    <div fxLayout="row" fxFlex="100">
      <p>
        {{ inputData.selectedItem.description }}
      </p>
    </div>
  </div>

  <div fxLayout="column" fxFlexAlign="stretch">
    <div fxLayout="row" fxFlex="100" style="text-align: center; padding: 1rem">
      <img class="image-to-show" [src]="inputData.selectedItem.imgUrl" />
    </div>
  </div>

  <div class="button-container" fxLayout="row" fxLayoutAlign="end stretch" fxLayoutGap="20px">
    <button mat-stroked-button color="primary" id="modal-confirm-button" (click)="cancelModal()">
      Abbrechen
    </button>

    <button mat-raised-button color="primary" id="modal-cancel-button" (click)="selectItem()">
      Auswählen
    </button>
  </div>
</mat-dialog-content>
